import { PDFIcon } from '@slal/ui/icons';
import { Heading } from '@slal/ui/typography';
import { useEffect } from 'react';
import { DocumentList, LinkButton, MaxWidthContent } from '~/components';
import { useIllustration } from '~/hooks';
import { IllustrationButtonLoadingSpinner } from './styles';

export const IllustrationButton = () => {
    const { getIllustration, loading, illustration } = useIllustration();
    const title = 'My personal illustration';

    useEffect(() => {
        if (!illustration) return;
        const fileUrl = URL.createObjectURL(illustration);
        const a = document.createElement('a');
        a.setAttribute('style', 'position:absolute;opacity:0;');
        a.setAttribute('href', fileUrl);
        a.setAttribute('download', title);
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }, [illustration, title]);

    return (
        <LinkButton aria-label={title} onClick={getIllustration}>
            <PDFIcon />
            {title}
            {loading && <IllustrationButtonLoadingSpinner title="Loading the illustration" />}
        </LinkButton>
    );
};

export const ReviewDocuments = () => {
    const id = 'your-documents-title';
    return (
        <MaxWidthContent>
            <Heading level={2} id={id}>
                Your documents
            </Heading>
            <DocumentList
                aria-labelledby={id}
                documents={[
                    <IllustrationButton />,
                    {
                        children: 'MoneyHelper guide',
                        href: 'https://library.standardlife.co.uk/mas_guide.pdf',
                    },
                ]}
            />
        </MaxWidthContent>
    );
};
